import React from "react";

export const PageTamil11 = () => {
  return (
    <div className="page-tamil-container">
      <div className="page-tamil-heading">
        <h1>ராசி</h1>
        <p>நக்ஷத்திரம் மற்றும் பாதங்கள்</p>
      </div>

      <table className="tamil-table">
        <thead>
          <tr>
            <th>ராசி</th>
            <th>நக்ஷத்திரம் மற்றும் பாதங்கள்</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>மேஷம் 1</td>
            <td>அசுவினி 1,2,3ம் பாதம், பரணி, கார்த்திகை 1ம் பாதம்</td>
          </tr>
          <tr>
            <td>ரிஷபம் 2</td>
            <td>கார்த்திகை 2,3,4ம் பாதம், ரோகிணி, மிருகசீரிடம் 1,2ம் பாதம்</td>
          </tr>
          <tr>
            <td>மிதுனம் 3</td>
            <td>
              மிருகசீரிடம் 3,4ம் பாதம், திருவாதிரை, புனர்பூசம் 1,2,3ம் பாதம்
            </td>
          </tr>
          <tr>
            <td>கடகம் 4</td>
            <td>புனர்பூசம் 4ம் பாதம், பூசம், ஆயில்யம்</td>
          </tr>
          <tr>
            <td>சிம்மம் 5</td>
            <td>மகம், பூரம், உத்திரம் 1ம் பாதம்</td>
          </tr>
          <tr>
            <td>கன்னி 6</td>
            <td>உத்திரம் 2,3,4ம் பாதம், அஸ்தம், சித்திரை 1,2ம் பாதம்</td>
          </tr>
          <tr>
            <td>துலாம் 7</td>
            <td>சித்திரை 3,4ம் பாதம், சுவாதி, விசாகம் 1,2,3ம் பாதம்</td>
          </tr>
          <tr>
            <td>விருச்சிகம் 8</td>
            <td>விசாகம் 4ம் பாதம், அனுஷம், கேட்டை</td>
          </tr>
          <tr>
            <td>தனுசு 9</td>
            <td>மூலம், பூராடம், உத்திராடம் 1ம் பாதம்</td>
          </tr>
          <tr>
            <td>மகரம் 10</td>
            <td>உத்திராடம் 2,3,4ம் பாதம், திருவோணம், அவிட்டம் 1,2ம் பாதம்</td>
          </tr>
          <tr>
            <td>கும்பம் 11</td>
            <td>அவிட்டம் 2,3,4ம் பாதம், சதயம், பூரட்டாதி 1,2,3ம் பாதம்</td>
          </tr>
          <tr>
            <td>மீனம் 12</td>
            <td>பூரட்டாதி 4ம் பாதம், உத்திரட்டாதி, ரேவதி</td>
          </tr>
        </tbody>
      </table>
      <p style={{marginTop:"10px"}}>
        இவற்றில் உள்ள 27 நட்சத்திரங்களில் 18 நட்சத்திரங்களுக்கு இந்த ராசி
        கட்டத்தில் தங்கள் ராசியை உடனே தெரிந்து கொள்ளலாம். மற்ற 9
        நட்சத்திரக்காரர்கள் குறிப்பிட்ட நட்சத்திரத்தில் எந்த பாதத்தில்
        பிறந்தவர்கள் என்று அவர்களுடைய ஜாதகத்தை பார்த்து அறிந்து பின்னர் ராசி
        தெரிந்து கொள்ளலாம்
      </p>
    </div>
  );
};
